var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"jiAyCTdQfL9y4jL6JpOfd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["account-frontend@kiwicom"]={id:"jiAyCTdQfL9y4jL6JpOfd"};
      